<template>
  <qs-drawer
    title="授权日志"
    :visible.sync="visible"
    :wrapperClosable="true"
    :modal-append-to-body="true"
    cusSize="xlg"
    class="auth-log-drawer"
  >
    <div class="drawer-content">
      <div class="company-title">{{ companyName }}</div>

      <el-table :data="tableData" style="width: 100%" border size="small" v-loading="loading">
        <el-table-column prop="operateTime" label="操作时间" min-width="160"></el-table-column>
        <el-table-column prop="operateName" label="操作内容" min-width="120"></el-table-column>
        <el-table-column prop="operatorName" label="操作人" min-width="120"></el-table-column>
        <el-table-column prop="afterStateName" label="操作后授权状态" min-width="140"></el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </qs-drawer>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { getSpAuthLog } from '@/api/domain/finance.js'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  companyName: {
    type: String,
    default: '',
  },
  authId: {
    type: [String, Number],
    default: '',
  },
})

const emit = defineEmits(['update:visible'])

const visible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)

const tableData = ref([])

const fetchData = async () => {
  if (!props.authId) return
  loading.value = true
  try {
    const { code, data } = await getSpAuthLog({
      id: props.authId,
      pageNum: currentPage.value,
      pageSize: pageSize.value,
    })
    if (code === 1) {
      tableData.value = data.items || []
      total.value = data.totalNum
    }
  } finally {
    loading.value = false
  }
}

const handleSizeChange = (val) => {
  pageSize.value = val
  fetchData()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchData()
}

// Reset pagination when opened
watch(() => props.visible, (val) => {
  if (val) {
    currentPage.value = 1
    fetchData()
  }
})
</script>

<style scoped lang="scss">
.auth-log-drawer {
  ::v-deep .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.drawer-content {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.company-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
